import {
  GET_PROFITABILITY_REPORT_REQUEST,
  GET_PROFITABILITY_REPORT_SUCCESS,
  GET_PROFITABILITY_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";


export const getProfitabilityReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_PROFITABILITY_REPORT_REQUEST });
 
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ProfitabilityReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: values,
  })
    .then((response) => {
      return dispatch({
        type: GET_PROFITABILITY_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PROFITABILITY_REPORT_ERROR,
        payload: [],
      });
    });
};